import { render } from "./size-guide-page.vue?vue&type=template&id=cbaa4504"
import script from "./size-guide-page.vue?vue&type=script&lang=js"
export * from "./size-guide-page.vue?vue&type=script&lang=js"

import "./size-guide-page.vue?vue&type=style&index=0&id=cbaa4504&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__